<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.processSetup.versionHistory.title')
      }}</v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <!-- <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup top text-->
      <v-card-text class="popup-title pb-0">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{ options.item.procNm }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top text-->
      <!-- [S]  Popup body-->
      <v-card-text class="pt-0 pb-0">
        <v-row>
          <v-col cols="12">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :items="versionList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width:51px">
                          {{ $t('tbl.mapManager.versionHistory.ver') }}
                        </th>
                        <th class="text-center text-version" style="width:29px">
                          {{ $t('tbl.mapManager.versionHistory.select') }}
                        </th>
                        <th class="text-center text-version" style="width:133px">
                          {{ $t('tbl.mapManager.versionHistory.date') }}
                        </th>
                        <th class="text-center text-version" style="width:133px">
                          {{ $t('tbl.mapManager.versionHistory.user') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.changeHistory') }}
                        </th>
                        <th class="text-center text-version" style="width:60px">
                          {{ $t('tbl.mapManager.versionHistory.delete') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">
                          <a class="link-file-text" @click="openProcessWindow(item)">{{
                            item.verNo
                          }}</a>
                        </td>
                        <td
                          v-if="item.currYN === 'Y'"
                          class="text-left align-radio"
                          style="width:29px"
                        >
                          <input
                            type="radio"
                            v-model="item.currYN"
                            :value="item.currYN"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.currYN === 'N'"
                          class="text-left align-radio"
                          style="width:29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left">{{ item.creDt }}</td>
                        <td class="text-left text-bold">{{ item.creUsrId }}</td>
                        <td class="text-left">{{ item.comment }}</td>
                        <td class="text-center">
                          <v-btn
                            v-if="item.currYN === 'Y' || item.verNo === currentVerItems.verNo"
                            small
                            disabled
                            text
                            icon
                          >
                            <icon-svg :disabled="true" iconName="delete" />
                          </v-btn>
                          <v-btn v-else small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right mr-4">
            <v-btn class="btn btn-popup btn-delete" @click="removeDialog">{{
              $t('btn.common.close')
            }}</v-btn>
            <v-btn
              class="btn btn-popup-search btn-popup"
              color="primary"
              tile
              @click="saveVersionHistory"
              :disabled="oldVersion === currentVerItems.verNo"
            >
              <!-- <v-icon small color="white" class="mr-1">fa fa-save</v-icon> -->
              {{ $t('btn.common.save') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the workflow version'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickDelete"
    ></dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      :detail="$t('msg.common.saveSuccess', ['Workflow version'])"
      color="success"
      @select-ok="saveOk"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

// 2021.10.22 203728 need waiting when change version
import { showProgress, hideProgress } from '@/vue-dlb/utils/sys-util.js';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { setProcessWindowList, deleteProcessWindow } from '@/vue-caas/utils/process';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    mapList: Array,
    sennderList: Array,
    receiverList: Array,
  },
  data: () => ({
    versionList: [],
    currentVerItems: {},
    seletedDelete: {},
    oldVersion: '',
    customHeight: 61,
    onSave: false,
  }),
  created() {
    this.queryList();
  },
  watch: {
    'options.item.procId'() {
      this.queryList();
    },
  },
  methods: {
    queryList() {
      // 2021.11.3 203728 SPKA-243 wait load list
      showProgress();
      this.$store
        .dispatch('processHistoryNew', {
          procId: this.options.item.procId,
          action: 'getHistoryList',
        })
        .then(() => {
          this.versionList = this.$store.getters.processHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.currYN === 'Y');
          this.oldVersion = this.currentVerItems.verNo;

          let len = this.versionList.length;
          this.customHeight = (len > 6 ? 6 : len) * 35 + (this.$vuetify.theme.dark ? 26 : 40);
          hideProgress();
        })
        .catch(() => {
          hideProgress();
        });
    },
    saveVersionHistory() {
      // 2021.10.22 203728 block click more
      // 2022.1.7 203728 SPKA-368 send actCd when change version
      if (this.onSave) return;
      showProgress();
      this.onSave = true;
      this.$store
        .dispatch('processHistoryNew', {
          procId: this.options.item.procId,
          verNo: this.currentVerItems.verNo * 10,
          mapList: this.mapList,
          receiverList: this.receiverList,
          senderList: this.sennderList,
          action: 'changeVersion',
          actCd: this.options.item.actCd,
          applyStatus: 'A',
        })
        .then(() => {
          this.versionList = this.$store.getters.processHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.currYN === 'Y');
          this.oldVersion = this.currentVerItems.verNo;
          hideProgress();
          this.onSave = false;
          this.$emit('refreshWFList');
        })
        .catch(() => {
          hideProgress();
          this.onSave = false;
        });
    },
    selectVersion(item) {
      this.currentVerItems = item;
    },
    saveOk() {
      this.$refs.successDialog.dialog = false;
      this.removeDialog();
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      // 2021.10.22 203728 block click more
      if (this.onSave) return;
      showProgress();
      this.onSave = true;
      this.$store
        .dispatch('processHistoryNew', {
          procId: this.options.item.procId,
          verNo: this.seletedDelete.verNo * 10,
          action: 'deleteHistory',
        })
        .then(() => {
          this.versionList = this.$store.getters.processHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.currYN === 'Y');
          this.oldVersion = this.currentVerItems.verNo;

          let len = this.versionList.length;
          this.customHeight = (len > 6 ? 6 : len) * 35 + (this.$vuetify.theme.dark ? 26 : 40);
          hideProgress();
          this.onSave = false;
        })
        .catch(() => {
          hideProgress();
          this.onSave = false;
        });
    },
    openProcessWindow(item) {
      const isHistory = true;
      const type = 'History';
      const params = {
        ROWID: item.procId.toString(),
        type: type,
        options: {
          dataValue: item.procId,
          id: item.procId.toString(),
          isHistory: isHistory,
          versionNo: item.verNo,
        },
      };
      const arrView = {
        item,
        type,
      };
      const url = `/process/workflowDetailNew/${type}/${params.ROWID}/${params.options.versionNo}`;
      const size = 'width=1800,height=950,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
  },
};
</script>
